const Revealer = function(options = {}) {
    const wrapperClass = options?.wrapperClass || 'js-revealer';
    const contentClass = options?.contentClass || 'js-revealer-content';
    const linkClass    = options?.linkClass || 'js-revealer-link';

    let items = [];

    const run = () => {
        const $body = $('body');
        const $items = $body.find(`.${wrapperClass}`);
        console.log(wrapperClass);

        $items.each((i, elem) => {
            const $this = $(elem);

            const $link    = $this.find(`.${linkClass}`);
            const $content = $this.find(`.${contentClass}`);

            const item = {
                $wrapper:    $this,
                $content:    $content,
                $link:       $link,
                startHeight: $content[0].clientHeight,
                endHeight:   $content[0].scrollHeight,
            }

            item.trigger = () => update(item);
            item.open = () => update(item, true);
            item.close = () => update(item, false);

            item.$link.on('click touchstart', (e) => {
                if(e.cancelable) e.preventDefault(); //touchstart can't call preventDefault
                item.trigger();
            }).on('touchend', (e) => {
                e.preventDefault(); //Call prevent default to stop the click
            });

            items.push(item);
        });
    }

    const update = (item, state = null) => {
        console.log(item);
        const $elem = item.$wrapper;
        const $content  = item.$content;
        if (!$content.length) return;

        const isOpen = $elem.hasClass('revealer--open');
        $elem.toggleClass('revealer--open');

        // const currentHeight  = $content[0].clientHeight;
        let newHeight = isOpen ? item.startHeight : item.endHeight;
        if (null !== state) newHeight = !state ? item.startHeight : item.endHeight;

        $content.stop().animate({height: `${newHeight}px`}, 800);
    }

    this.run = () => run();
    this.update = (item, state) => update(item, state);
}